export default "__VITE_PUBLIC_ASSET__efac5e2b__"